// extracted by mini-css-extract-plugin
export default {"Modal":"style_Modal__vLzGO","Controls":"style_Controls__hcVI0"};